'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sr_LazyRef() {
  this.V = false;
  this.W = null;
}
export { $c_sr_LazyRef as $c_sr_LazyRef };
$p = $c_sr_LazyRef.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_sr_LazyRef;
/** @constructor */
function $h_sr_LazyRef() {
}
export { $h_sr_LazyRef as $h_sr_LazyRef };
$h_sr_LazyRef.prototype = $p;
$p.az = (function(value) {
  this.W = value;
  this.V = true;
  return value;
});
$p.b = (function() {
  return ("LazyRef " + (this.V ? ("of: " + this.W) : "thunk"));
});
var $d_sr_LazyRef = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sr_LazyRef, "scala.runtime.LazyRef", ({
  vF: 1,
  a: 1
}));
export { $d_sr_LazyRef as $d_sr_LazyRef };
